import React from 'react';
import style from './index.module.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const MyFooter = (props) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	const socialIcons = [
		{ icon: <WhatsAppIcon />, link: 'https://api.whatsapp.com/send?phone=919827078928' },
		{ icon: <FacebookIcon />, link: 'https://www.facebook.com/profile.php?id=100088026692168' },
		{ icon: <InstagramIcon />, link: 'https://www.instagram.com/shriharitenthouse/' },
		{ icon: <YouTubeIcon />, link: 'https://www.youtube.com/' },
		{ icon: <WhatsAppIcon />, link: 'https://api.whatsapp.com/send?phone=919300661900' },
	];

	return (
		<footer 
			className={style.footer}
			style={{
				backgroundColor: isDark ? '#050505' : theme.palette.primary.dark,
				color: '#fff',
			}}
		>
			<div className={style.firstSection}>
				<div className={style.footerLeftSection}>
					<h1 className={style.footerTitle}>
						<span style={{ borderBottomColor: theme.palette.secondary.main }}>About</span> Us
					</h1>
					<p className={style.footerText}>
						Shri Hari Tent House has been a cornerstone of grand celebrations for years. 
						Our dedicated team of professionals brings extensive experience in events, 
						decor, and planning to make your special moments unforgettable.
					</p>
				</div>
				<div className={style.footerMiddleSection}>
					<div className={style.mapWrapper}>
						<iframe
							title="Location Map"
							src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1228.7796178479978!2d76.7302392!3d23.0239513!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397cc4a6524ed9e5%3A0x25e9b0ad290ab416!2zMjPCsDAxJzI1LjYiTiA3NsKwNDMnNDkuOSJF!5e1!3m2!1sen!2sin!4v1671201994951!5m2!1sen!2sin'
							width='100%'
							height='250'
							style={{ border: 0, borderRadius: '1rem' }}
							allowFullScreen=''
							loading='lazy'
							referrerPolicy='no-referrer-when-downgrade'
						></iframe>
					</div>
				</div>
				<div className={style.footerRightSection}>
					<h2 className={style.footerTitle}>
						<span style={{ borderBottomColor: theme.palette.secondary.main }}>Contact</span> Info
					</h2>
					<p className={style.contactItem}>
						<strong>Address:</strong> 13, Mugli road, Near Bhopal Naka, Ashta - 466116, Sehore (M.P.), India
					</p>
					<p className={style.contactItem}>
						<strong>Deependra:</strong> +91 9827078928
					</p>
					<p className={style.contactItem}>
						<strong>Dharmendra:</strong> +91 9300661900
					</p>
					
					<div className={style.socialLinks}>
						{socialIcons.map((social, index) => (
							<motion.a
								key={index}
								href={social.link}
								target='_blank'
								rel="noopener noreferrer"
								whileHover={{ scale: 1.2, color: theme.palette.secondary.main }}
								style={{ color: '#fff', margin: '0.5rem' }}
							>
								{social.icon}
							</motion.a>
						))}
					</div>
				</div>
			</div>
			<div className={style.secondSection}>
				<p className={style.copyright}>
					<strong>Shri Hari Tent House</strong> © {new Date().getFullYear()}. All Rights Reserved.
				</p>
				<p className={style.developer}>
					Crafted with ❤️ by <span style={{ color: theme.palette.secondary.main }}>KUNDAN THAKUR</span>
				</p>
			</div>
		</footer>
	);
};

export default MyFooter;
